import {
    Tooltip,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./pqIndexStyle";
import { selectAktuellerGrenzwertsatzTemp, selectSelectedTab, updateSelectedTabAll } from "./pqIndexSlice";
import ColorValues from "./colorTableCell";
import { selectKenngroesseWertTemp } from '../../../features/filter/kenngroesseSlice';
import { selectMessstelleWertTemp, selectSliderTemp } from '../../../features/filter/messstellenFilterSlice';
import { selectStartDatumTemp, selectEndeDatum } from '../../../features/filter/zeitSlice';
import { messstelle } from "../../../utils/apiTypes";
import { colNameType, pqIndexResult } from "./pqIndexTypes";
import { getMessstelleZeit, selectMessstelleZeit } from "./messstelleTableSlice";
import { selectUWMinZeitAll, selectUwZeit, selectUWZeitListe, selectZeitMinUwListe, selectZeitMinZeitListe } from "./uwZeitTableSlice";
import LegendePQIndex from "./legendePQIndex";

export default function UmspannwerkZeitGrid(): ReactElement {

    const dispatch = useAppDispatch();
    const classes = {

        ...globalStyles(),
        ...useStyles()
    };

    const uwZeit = useAppSelector(selectUwZeit);
    const messstelleZeit = useAppSelector(selectMessstelleZeit);
    const kwListe = useAppSelector(selectUWZeitListe);
    const minUwListe = useAppSelector(selectZeitMinUwListe);
    const minZeitListe = useAppSelector(selectZeitMinZeitListe);
    const minValueAll = useAppSelector(selectUWMinZeitAll);

    const grenzwertsatz = useAppSelector(selectAktuellerGrenzwertsatzTemp);
    const kenngroesseFilterWert = useAppSelector(selectKenngroesseWertTemp);
    const messstelleFilterWert = useAppSelector(selectMessstelleWertTemp);
    const pqIndexSlider = useAppSelector(selectSliderTemp);
    const startDatum = useAppSelector(selectStartDatumTemp);
    const endeDatum = useAppSelector(selectEndeDatum);

    const selectedTab = useAppSelector(selectSelectedTab);


    function openMesstelleZeitGrid(uw: string) {
        let isInMessstelleZeitList = false;
        const MessstelleFilteredListe: messstelle[] = [];
        for (let index = 0; index < messstelleFilterWert.length; index++) {
            // eslint-disable-next-line security/detect-object-injection
            const element = messstelleFilterWert[index];
            if (element.umspannwerk == uw) {
                MessstelleFilteredListe.push(element)
            }
        }
        for (let index = 0; index < messstelleZeit.length; index++) {
            // eslint-disable-next-line security/detect-object-injection
            if (uw == messstelleZeit[index].uw) {
                isInMessstelleZeitList = true;
            }
        }
        if (!isInMessstelleZeitList) {
            dispatch(getMessstelleZeit(MessstelleFilteredListe, kenngroesseFilterWert, startDatum, endeDatum, pqIndexSlider[0], pqIndexSlider[1], grenzwertsatz, false, true, uw));
            dispatch(updateSelectedTabAll(uw + "zeit", selectedTab))
        }
    }

    function createTableCell(kwElem: colNameType, rows: pqIndexResult[]) {
        const rowsMaxIndex = rows.length
        let rowsIndex = 0;
        const cellValue = 11;
        while (rowsMaxIndex > rowsIndex) {
            // eslint-disable-next-line security/detect-object-injection
            if (kwElem.col == rows[rowsIndex].col) {
                // eslint-disable-next-line security/detect-object-injection
                return (<ColorValues value={rows[rowsIndex].value} />)
            }
            rowsIndex += 1;
        }
        return (<ColorValues value={cellValue} />)
    }

    return (
        <React.Fragment>
            <Grid item md={12} style={{ textAlign: 'left', marginRight: "20px" }}>
                <div >
                    <LegendePQIndex />
                    <TableContainer component={Paper} style={{ height: '80vh' }}>
                        <Table aria-label="simple table" className={classes.table}>
                            <TableHead>
                                <TableCell className={classes.tableHeaderHorizontalLeftmost}>Umspannwerk / KW</TableCell>
                                {kwListe.map((elem, index) => (
                                    <TableCell key={index} className={classes.tableHeaderHorizontal}>{elem.name}</TableCell>
                                ))}
                                <TableCell className={classes.tableHeaderHorizontalBlank} style={{ width: "20px" }} />
                                <TableCell className={classes.tableHeaderHorizontal}>Alle Umspannwerke</TableCell>
                            </TableHead>
                            <TableBody>
                                {uwZeit.map((rows, index) => (
                                    <TableRow key={rows[0].row} >
                                        <Tooltip title="Zeige die Werte für die dazugehörigen Messstellen.">
                                            <TableCell
                                                style={{ cursor: "pointer" }}
                                                className={classes.tableHeaderVerticalClickable}
                                                component="th"
                                                scope="rows"
                                                onClick={() => (
                                                    openMesstelleZeitGrid(rows[0].row)
                                                )}
                                            >{rows[0].row}</TableCell>
                                        </Tooltip>
                                        {kwListe.map((kwElem) =>
                                            createTableCell(kwElem, rows)
                                        )}
                                        <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                        {/* eslint-disable-next-line security/detect-object-injection*/}
                                        <ColorValues value={minUwListe[index]} />
                                    </TableRow>
                                ))}
                                <TableRow >
                                    <TableCell />
                                </TableRow>
                                <TableRow >
                                    <TableCell style={{ width: "295px" }} component="th" scope="rows" className={classes.tableHeaderVertical}>Gesamte Zeit</TableCell>
                                    {minZeitListe.map((elem, index) => (
                                        <ColorValues key={index} value={elem} />
                                    ))}
                                    <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                    <ColorValues value={minValueAll} />

                                </TableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Grid>
        </React.Fragment>
    );
}
